import axiosInstance from '../../axiosInstance';

const revokeGoLivePermission = async ({ userId }) => {
  const response = await axiosInstance.delete(
    `/api/admin-actions/v2/special-user-permissions/can-go-live/${userId}`,
  );

  const { data } = response.data;

  return data;
};

export default revokeGoLivePermission;
